import Seo from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/images";

const CHAPTERS = [
  {
    num: "01",
    slug: "my-story",
    title: "My Story",
    text: "This chapter is being written. Derrick's full story — where the music began and the road that led here — will be shared soon.",
  },
  {
    num: "02",
    slug: "why-i-sing",
    title: "Why I Sing",
    text: "Every singer has a reason. Derrick's own words on why he sings will live here.",
  },
  {
    num: "03",
    slug: "musical-influences",
    title: "Musical Influences",
    text: "The voices, songs, and traditions that shaped Derrick's singing will be introduced here.",
  },
  {
    num: "04",
    slug: "connecting-through-music",
    title: "Connecting Through Music",
    text: "On what happens between a singer and a room full of listeners — in Derrick's words, coming soon.",
  },
];

export default function About() {
  return (
    <>
      <Seo
        title="About — Derrick Hall"
        siteName="Derrick Hall"
        description="About Derrick Hall, singer and vocalist — his story, why he sings, and the music that shaped him."
      />
      <PageHeader
        testId="about-header"
        eyebrow="About"
        title="The man behind the voice"
        description="Derrick's biography is being written and will be published here. The chapters below mark where his story will unfold."
      />

      <div className="mx-auto max-w-5xl px-6 pb-28">
        <Reveal className="relative mb-20">
          <div className="absolute -left-4 -top-4 h-full w-full border border-gold/25" />
          <img
            src={IMAGES.pianoKeys}
            alt="Acoustic piano keys in warm, soft light"
            className="relative aspect-[21/9] w-full object-cover"
            data-testid="about-image"
          />
        </Reveal>

        <div data-testid="about-chapters">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.slug} delay={0.05 * i}>
              <article
                id={c.slug}
                data-testid={`about-chapter-${c.slug}`}
                className="grid gap-6 border-t border-white/[0.08] py-12 sm:grid-cols-[6rem_1fr] sm:gap-12"
              >
                <span className="font-serif text-5xl font-light text-outline sm:text-6xl">{c.num}</span>
                <div>
                  <h2 className="font-serif text-2xl sm:text-3xl font-light text-sand-bright">{c.title}</h2>
                  <p className="mt-4 max-w-2xl text-base font-light leading-relaxed text-mist">{c.text}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </>
  );
}
